import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { TJobObject } from "@/features/job/types/JobForm";
import { black, text } from "@/theme/colors";
import { IconCheckCircle } from "@/assets/icons/IconCheckCircle";
import { EMPTY_STR } from "@/constants/string";

type TJobObjectFieldsDetailProps = {
  title: string;
  data: TJobObject[] | undefined | null;
};

export const JobObjectFieldsDetail: FC<TJobObjectFieldsDetailProps> = ({ title, data }) => {
  // Guard: parse JSON string if BE returns stringified array (e.g. from bulk import)
  const parsedData = (() => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === "string") {
      try {
        const parsed = JSON.parse(data);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  })();
  const checkedItems = parsedData.filter((item) => item.checked);
  return (
    <>
      <Typography variant="cap12Light" color={black[70]} ml={3} pb={0.5}>
        {title}
      </Typography>

      {checkedItems.length === 0 ? (
        <Typography>{EMPTY_STR.TEXT}</Typography>
      ) : (
        checkedItems.map((item, index) => (
          <Stack key={index} direction="row" alignItems="flex-start" gap={1}>
            <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", mt: "2px" }}>
              <IconCheckCircle width={16} height={16} />
            </Box>
            <Typography
              variant="body14"
              color={text.primary}
              sx={{
                fontFamily: "inherit",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                overflowWrap: "break-word",
              }}
            >
              {item.label}
            </Typography>
          </Stack>
        ))
      )}
    </>
  );
};
